<template>
	<UiNavigationNavbarMobile>
		<UiNavigationNavbarMobileLink
			v-if="!noHome"
			to="/"
			icon="home"
			primary
			:active="isActiveRoute('/')"
		/>
		<UiNavigationNavbarMobileLink
			v-for="item in displayItems"
			:key="item.id"
			:to="item.to"
			:icon="item.icon"
			:title="item.title"
			:active="item.to ? isActiveRoute(item.to) : false"
		/>
	</UiNavigationNavbarMobile>
</template>

<script lang="ts" setup>
import type { SidebarLinkItem } from "./sidebarLinkList.vue";

interface Props {
	items: SidebarLinkItem[];
	noHome?: boolean;
	reverse?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	noHome: false,
	reverse: false,
});

const displayItems = computed(() => props.reverse ? [...props.items].reverse() : props.items);

const route = useRoute();

function isActiveRoute(routePath: string): boolean {
	return route.path === routePath;
}
</script>
